import { render, staticRenderFns } from "./tab-iframe.vue?vue&type=template&id=3993a716&scoped=true&"
import script from "./tab-iframe.vue?vue&type=script&lang=js&"
export * from "./tab-iframe.vue?vue&type=script&lang=js&"
import style0 from "./tab-iframe.vue?vue&type=style&index=0&id=3993a716&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993a716",
  null
  
)

export default component.exports